<div class="flex">
  <div class="flex-item">
    <div style="display: block;">
      <canvas baseChart height="200" [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
        [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins"
       ></canvas>
    </div>
  </div>
</div>